import { Extension } from "../../core/extension";
import { SlashCommandGroup, } from "../../core/types";
import { aiPlugin, openAiPopup } from "./plugins/ai-plugin";
export class AiExtension extends Extension {
    constructor(service) {
        super();
        this.service = service;
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return plugins.concat([aiPlugin(portalContainer, this.service)]);
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            {
                label: `Ask AI`,
                description: `Use AI to generate or improve text`,
                group: SlashCommandGroup.Ai,
                icon: "stars",
                iconColor: "#FFD700",
                command: (match, view) => {
                    const { from, to } = match.range;
                    if (from && to) {
                        const tr = view.state.tr;
                        tr.deleteRange(from, to);
                        view.dispatch(tr);
                        openAiPopup(view);
                    }
                },
            },
        ];
    }
    addCommands(schema) {
        return {
            askAi: {
                active: () => false,
                enable: () => true,
                run: (state, dispatch, view) => {
                    openAiPopup(view);
                },
            },
        };
    }
}
